<template>
  <div>
    <iModal
      title="Change password"
      :closable="false"
      :mask-closable="false"
      v-model="showModal"
      class-name="vertical-center-modal"
      width="600px"
      @on-cancel="cancel"
    >
      <div class="account-add" style="padding-right: 20px;">
        <div class="account-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="130"
            @submit.native.prevent
          >
            <FormItem label="old password：" prop="password">
              <Input type="text" v-model="formInline.password" placeholder="old password" />
            </FormItem>
            <FormItem label="new password：" prop="repassword">
              <Input type="text" v-model="formInline.repassword" placeholder="new password" />
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">Save</Button>
        <Button @click="cancel">Cancel</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { validator } from "@/other/validatorEn";
import { mapActions, mapGetters } from "vuex";

export default {
  // 修改密码
  name: "changePassword",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.formInline.password) {
        callback(new Error("两次密码不匹配!"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      showModal: false,
      formInline: {
        // form双向绑定
        password: "",
        repassword: ""
      }, 
      // ruleInline: {
      //   // 效验规则
      //   password: validator.password,
      //   repassword: validator.password, 
      // },
      ruleInline: {
        // 效验规则
        password: [{ required: true, message: "Please enter password", trigger: "blur" }],
        repassword: [
          { required: true, message: "Please enter password", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              const regex = /^(?:(?=.*[a-z])(?=.*[A-Z])(?=.*\d)|(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_])|(?=.*[a-z])(?=.*\d)(?=.*[\W_])|(?=.*[A-Z])(?=.*\d)(?=.*[\W_])).{8,}$/;
              if (!value) {
                callback("Please enter password");
              } else if (regex.test(value)) {
                callback();
              } else {
                callback("Passwords should be more than 8 characters long and contain at least two combinations of uppercase and lowercase letters, numbers, symbols, etc.");
              }
            },
            trigger: "blur"
          }
        ],
      }
    };
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    }
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany"
    })
  },
  created() {},
  methods: {
    ...mapActions({
      getStaffByCompId: "companyModule/getStaffByCompId",
      changePasswordByOld: "loginModule/changePasswordByOld"
    }),
    async init() {
      let arr = [];
      let staffArr = await this.getStaffByCompId(this.company.id);
      staffArr.forEach(c => {
        // if (c.roleId === 1) {
          this.adminInfo = c;
        // }
      });
    },
    async handleSubmit(name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      let formData = {
        UserId: this.user.id,
        CurrentPassword: form.password,
        NewPassword: form.repassword
      }; 
      let bool = await this.changePasswordByOld(formData);
      if (!bool) {
        this.$Message.error("修改失败，请重新尝试!");
        return false;
      }
      if (bool.errors && bool.errors[0]) { 
        if (bool.errors[0].code === -1) {
          this.$Message.error("The old password is wrong");
          return;
        }
        this.$Message.error(bool.errors[0].description);
        return;
      }
      this.$Message.success("修改成功!");
      this.cancel();
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel() {
      this.showModal = false;
      if (this.$refs["formInline"]) {
        this.$refs["formInline"].resetFields();
      }
      this.$emit("finish");
      this.$emit("close");
    }
  }
};
</script>

<style scoped lang="scss">
.account-add {
  padding-right: 20px;
  padding-top: 20px;
}
</style>

